<script>	
	import Painel from './Painel.svelte';

	const opcoes = [
		{
			titulo: "Voltar", 
			icone: "voltar",
			link: "#/painel",
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		},
		{ 
			titulo: "Cadastrar", 
			icone: "salvar",
			link: "#/projeto/cadastro",
			perfis: "COORDENADOR"
		},
		{ 
			titulo: "Meus Projetos", 
			icone: "projeto",
			link: "#/usuario/meus-projetos",
			perfis: "COORDENADOR,DISCENTE"
		},
		{ 
			titulo: "Semana Grad.", 
			icone: "apresentacao",
			link: "#/projeto/apresentacao",
			perfis: "COORDENADOR"
		},
		{ 
			titulo: "Indicar", 
			icone: "indicar",
			link: "#/projeto/indicar-discente",
			perfis: "COORDENADOR"
		},
		{
			titulo: "Indicar Coord.",
			icone: "indicar",
			link: "#/projeto/indicar-coordenador",
			perfis: "CETREINA"
		},
		{
			titulo: "Buscar", 
			icone: "buscar",
			link: "#/busca/formulario/projeto",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Listar", 
			icone: "listar",
			link: "#/projeto/listagem",
			perfis: "CETREINA,AVALIADOR"
		}
	];
</script>

<Painel 
	titulo="Painel de Projetos" 
	listaFuncionalidades={opcoes}>
</Painel>